import { React } from '../libraries'

export const Title = (props) => {
  return <h2 className='dots mb-3 mt-4'>{props.children}</h2>
}
